module.exports = __webpack_public_path__ + "img/timeline.cce6df24.jpg";